<template>
    <span>
      <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col md="10">
                    <h3>Captchas</h3>
                 </b-col>
                 <b-col md="2">
                    <b-button v-if="can('captcha.store')" @click="navigate('/captcha/cadastrar')" block variant="primary">
                         <i class="fa fa-plus"></i>
                       <span>Novo Captcha</span>
                    </b-button>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
            <b-row>
                <b-col sm="12">
                    <b-form-group label="Nome do captcha:">
                        <b-form-input type="text" id="name" v-model="filtros.filter" placeholder="Nome do captcha"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="3">
                    <b-form-group>
                        <b-form-group label="Status:">
                            <b-form-checkbox-group v-model="filtros.status" id="checkbox-group-2" name="flavour-2">
                                <b-form-checkbox :value="1">Ativo</b-form-checkbox>
                                <b-form-checkbox :value="0">Inativo</b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-form-group>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card-body>
        <b-row>
            <b-col sm="12">
                <b-container fluid>
                       <span>
                          <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
                          <thead>
                            <tr>
                              <th scope="col">Nome</th>
                              <th scope="col">Status</th>
                              <th scope="col">Ações</th>
                            </tr>
                          </thead>
                          <tbody v-if="captchas.data !== undefined">
                            <tr v-for="captcha in captchas.data" :key="captcha.id">
                              <td>{{captcha.nome}}</td>
                              <td>
                                <span v-if="captcha.ativo" class="badge badge-success">Ativo</span>
                                <span v-else class="badge badge-dark">Inativo</span>
                              </td>
                              <td style="width: 15%">
                                  <a v-if="can('captcha.update')" class="btn btn-sm btn-secondary action" title="Editar Captcha" @click="editarCaptcha(captcha.id)">
                                     <i class="fa fa-pencil-square-o"></i>
                                  </a>
                                  <a v-if="can('captcha.destroy')" class="btn btn-sm btn-secondary action" title="Excluir Captcha" @click="excluirCaptcha(captcha.id)">
                                   <i class="fa fa-times"></i>
                                  </a>

                                 <span v-if="can('captcha.suspender') && captcha.ativo">
                                     <a class="btn btn-sm btn-secondary action" title="Inativar Captcha" @click="suspenderCaptcha(captcha.id)">
                                      <i class="fa fa-toggle-on"></i>
                                     </a>
                                  </span>
                                 <span v-if="can('captcha.show') && !captcha.ativo">
                                     <a class="btn btn-sm btn-secondary action" title="Ativar Captcha" @click="ativarCaptcha(captcha.id)">
                                      <i class="fa fa-toggle-off"></i>
                                     </a>
                                  </span>
                                  <span>
                                     <a class="btn btn-sm btn-secondary action" title="Simular Captcha" @click="simularCaptcha(captcha.id, captcha.video)">
                                      <i class="fa fa-play"></i>
                                     </a>
                                  </span>
                              </td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                           <tr class="action">
                             <td colspan="5">Nenhum registro de captchas...</td>
                           </tr>
                          </tbody>
                         </table>
                         <pagination v-show="captchas.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource"></pagination>
                       </span>
                </b-container>
            </b-col>
        </b-row>
      </b-card>
      <b-modal title="Simulação do Captcha" size="lg" hide-footer v-model="modalSimular">
         <b-card-body>
           <b-form>
                <h3>Vídeo do captcha</h3>
                <video controls id="video1" style="width: 100%; height: auto; margin:0 auto; frameborder:0;">
                   <source :src="videoSimular" type="video/mp4">
                </video>
                <br>
                <br>
                <h3>Respostas</h3>
                <p>(Selecione a resposta corrreta)</p>
                <div>
                 <b-container fluid class="p-4">
                    <span v-if="captchaSimular.numero_alternativas === 3">
                        <b-row>
                            <b-col>
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[0].correta)" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[0].foto" :alt="captchaSimular.respostas[0].texto"></b-img>
                            </b-col>
                             <b-col>
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[1].correta)" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[1].foto" :alt="captchaSimular.respostas[1].texto"></b-img>
                            </b-col>
                             <b-col>
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[2].correta)" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[2].foto" :alt="captchaSimular.respostas[2].texto"></b-img>
                            </b-col>
                        </b-row>
                    </span>
                    <span v-if="captchaSimular.numero_alternativas === 6">
                        <b-row>
                            <b-col>
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[0].correta)"  v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[0].foto" :alt="captchaSimular.respostas[0].texto"></b-img>
                            </b-col>
                             <b-col>
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[1].correta)"  v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[1].foto" :alt="captchaSimular.respostas[1].texto"></b-img>
                            </b-col>
                             <b-col>
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[2].correta)" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[2].foto" :alt="captchaSimular.respostas[2].texto"></b-img>
                            </b-col>
                        </b-row>
                        <br>
                         <b-row>
                            <b-col>
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[3].correta)" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[3].foto" :alt="captchaSimular.respostas[3].texto"></b-img>
                            </b-col>
                             <b-col>
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[4].correta)"  v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[4].foto" :alt="captchaSimular.respostas[4].texto"></b-img>
                            </b-col>
                             <b-col>
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[5].correta)"  v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[5].foto" :alt="captchaSimular.respostas[5].texto"></b-img>
                            </b-col>
                        </b-row>
                    </span>
                    <span v-if="captchaSimular.numero_alternativas === 9">
                        <b-row>
                            <b-col>
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[0].correta)" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[0].foto" :alt="captchaSimular.respostas[0].texto"></b-img>
                            </b-col>
                             <b-col>
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[1].correta)" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[1].foto" :alt="captchaSimular.respostas[1].texto"></b-img>
                            </b-col>
                             <b-col>
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[2].correta)"  v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[2].foto" :alt="captchaSimular.respostas[2].texto"></b-img>
                            </b-col>
                        </b-row>
                        <br>
                         <b-row>
                            <b-col>
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[3].correta)" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[3].foto" :alt="captchaSimular.respostas[3].texto"></b-img>
                            </b-col>
                             <b-col>
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[4].correta)" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[4].foto" :alt="captchaSimular.respostas[4].texto"></b-img>
                            </b-col>
                             <b-col>
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[5].correta)" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[5].foto" :alt="captchaSimular.respostas[5].texto"></b-img>
                            </b-col>
                        </b-row>
                        <br>
                        <b-row>
                            <b-col>
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[6].correta)" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[6].foto" :alt="captchaSimular.respostas[6].texto"></b-img>
                            </b-col>
                             <b-col>
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[7].correta)" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[7].foto" :alt="captchaSimular.respostas[7].texto"></b-img>
                            </b-col>
                             <b-col>
                                <b-img class="action" @click="informarRespostaCerta(captchaSimular.respostas[8].correta)" v-bind="mainProps" thumbnail wi fluid :src="captchaSimular.respostas[8].foto" :alt="captchaSimular.respostas[8].texto"></b-img>
                            </b-col>
                        </b-row>
                    </span>
                </b-container>
                <div>
                 <b-alert show variant="success" v-if="respostaCerta">
                   <h4 class="alert-heading">Parabéns!</h4>
                   <p>Sua resposta está correta :)</p>
                   <p>Acertou em ({{tentativas}}) tentativas</p>
                 </b-alert>
                 <b-alert show variant="danger" v-if="respostaErrada">
                   <h4 class="alert-heading">Ops...</h4>
                   <p>Sua resposta está incorreta :|</p>
                   <p>Tentativas: ({{countadorErros}})</p>
                 </b-alert>
                </div>
                </div>
           </b-form>
        </b-card-body>
      </b-modal>
    </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import {eventType} from '@/components/shared/eventType'
import miniToastr from 'mini-toastr'

miniToastr.init()

export default {
  components: {
    Pagination
  },
  created () {
    if (!this.can('captcha.show')) {
      this.$router.push('/')
    }
  },
  data () {
    return {
      mainProps: {width: 250, height: 250},
      videoSimular: '',
      respostaFinal: false,
      countadorErros: 0,
      tentativas: 1,
      respostaErrada: false,
      respostaCerta: false,
      modalSimular: false,
      totalPorPagina: 5,
      resource: 'captcha',
      filtros: {
        filter: '',
        status: null
      }
    }
  },
  computed: {
    captchas () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    captchaSimular () {
      return this.$store.state.captcha.captcha
    }
  },
  watch: {
    'filtros.filter': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
    },
    'filtros.status': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
      this.setarFiltros(this.filtros)
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    editarCaptcha (id) {
      this.$router.push('/captcha/' + id + '/editar')
    },
    excluirCaptcha (id) {
      this.$bvModal.msgBoxConfirm('Deseja realmente excluir esse captcha?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.delete('api/captcha/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    suspenderCaptcha (id) {
      this.$bvModal.msgBoxConfirm('Confirma a inativação do registro selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.get('api/captcha/suspender/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
        }
      })
    },
    ativarCaptcha (id) {
      this.$bvModal.msgBoxConfirm('Confirma a ativação do registro selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.get('api/captcha/ativar/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
        }
      })
    },
    simularCaptcha (id, video) {
      this.countadorErros = 0
      this.tentativas = 1
      this.respostaErrada = false
      this.respostaCerta = false
      this.videoSimular = video
      this.$store.dispatch('getCaptcha', id)
      this.simularCaptcha2()
    },
    simularCaptcha2 () {
      this.modalSimular = true
    },
    navigate (route) {
      this.$router.push(route)
    },
    informarRespostaCerta (resposta) {
      if (resposta) {
        this.respostaCerta = true
        this.respostaErrada = false
        this.countadorErros = 0
        if (!this.respostaFinal) {
          if (this.tentativas === 1) {
            this.tentativas = this.tentativas
          } else {
            this.tentativas = this.tentativas + 1
          }
        }
        this.respostaFinal = true
      } else {
        this.respostaCerta = false
        this.respostaErrada = true
        this.countadorErros = this.countadorErros + 1
        this.tentativas = this.countadorErros
        this.respostaFinal = false
      }
    }
  }
}
</script>

<style scoped>
    .action{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/captchas/Captchas.vue